@if (!disabled()) {
  <mat-form-field
    appearance="outline"
    class="sia-inputs-full sia-input"
    floatLabel="always"
    [class]="inputClass()"
    [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  >
    <mat-label
      >{{ label() | siaTranslate }}

      @if (info()) {
        <span
          [siaTooltip]="info() ?? ''"
          position="right"
          class="sia-info"
          [innerHTML]="infoIcon()"
        >
        </span>
      }
    </mat-label>
    <span class="number-input">
      <input
        matInput
        [ngModel]="stringValue()"
        (ngModelChange)="onStringValueChange($event)"
        (blur)="onBlur()"
        [disabled]="isDisabled()"
        (keyup.enter)="enterPressed.emit($event)"
        type="string"
        inputmode="decimal"
        [id]="id() ?? ''"
        [tabindex]="tabDisabled() ? '-1' : '0'"
      />
    </span>
    @if (showBottomMargin()) {
      <mat-hint
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </mat-form-field>
}
@if (disabled()) {
  <mat-form-field
    appearance="outline"
    class="sia-inputs-full sia-input"
    floatLabel="always"
    [class]="inputClass()"
    [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  >
    @if (label()) {
      <mat-label>
        {{ label() | siaTranslate }}
        @if (info()) {
          <span
            [siaTooltip]="info() ?? ''"
            position="right"
            class="sia-info"
            [innerHTML]="infoIcon()"
          >
          </span>
        }
      </mat-label>
    }
    <input
      matInput
      [value]="getFormatValue()"
      [disabled]="disabled()"
      [id]="id() ?? ''"
      [tabindex]="tabDisabled() ? '-1' : '0'"
    />
    @if (showBottomMargin()) {
      <mat-hint
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </mat-form-field>
}
